'use client';

import { VercelToolbar as VercelToolbarComponent } from '@vercel/toolbar/next';

export function VercelToolbar() {
  // Ne monter la toolbar que sur Vercel pour éviter tout crash hors Vercel
  if (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_VERCEL !== '1') {
    return null;
  }
  return <VercelToolbarComponent />;
}

